<template>
  <div class="title-wrap">
    <img 
      :src="titleUrl"
    />
  </div>
</template>

<script>
export default {
  name: "Index",
  props: {
    titleUrl: {
      
    }
  }
};
</script>

<style lang="scss" scoped>
.title-wrap{
  border-top: 2px dotted  #D9BAB7;
  padding-top: 40px;
  padding-bottom: 40px;
  img{
    height: 31px;
    display: block;
    margin: 0 auto;
  }
}
</style>